import { EventType } from '@/analytics/types';
import { useHubspotFormsContext } from '@/app/[locale]/business/_contexts/HubspotFormsContext';
import LandingPageBlurb from '@/app/components/LandingPage/LandingPageBlurb';
import { BUSINESS_PATHNAME } from '@/app/consts/pathnames';

import { HUBSPOT_SELECTION_MODAL_ID } from '../HubspotSelectionModal';

const BusinessContactUs = () => {
  const { setActiveModal } = useHubspotFormsContext();

  const handleClick = (): void => {
    setActiveModal(HUBSPOT_SELECTION_MODAL_ID);

    void window.ouraAnalytics.track(EventType.LinkClicked, {
      cta: 'contact_us',
      location: 'body',
      path: BUSINESS_PATHNAME,
    });
  };

  return (
    <section data-cy="business-contact-us" className="pt-20 pb-5">
      <LandingPageBlurb
        action={{
          dataCy: 'business-contact-us-action-button',
          title: 'business_contact_us_action',
          onClick: handleClick,
        }}
        description={{
          alignment: 'top',
          key: 'business_contact_us_description',
        }}
        title={{
          colEnd: { lg: 13, xxl: 11 },
          key: 'business_contact_us_title',
          multiline: true,
        }}
      />
    </section>
  );
};

export default BusinessContactUs;
